import callApi, { ENDPOINTS } from 'utils/api/callApi'
import { IFiltersParams } from '../hooks/useFilters'
import { IEquipment } from './rfpLaneRates'

export interface IRFPLane {
  id: string
  laneId: string
  rfpTitle: string
  shipperName: string
  salesforceRfpId: string
  pickupDatMarket: string
  deliveryDatMarket: string
  pickupCity: string
  pickupStateCode: string
  deliveryCity: string
  deliveryStateCode: string
  grossVolume?: string
  equipment: IEquipment
  dropType: string
}

export interface IRFPLaneResponse {
  requestForProposalLanes: IRFPLane[]
}

export interface IRFPLaneSpecificFilters {
  shipperApplicationId?: string
  rfpTitle?: string
  pickupCity?: string
  pickupStateCode?: string
  deliveryCity?: string
  deliveryStateCode?: string
  laneId?: string
  id?: string
  salesforceRfpId?: string
}

export interface IRFPLaneFilters extends IFiltersParams<IRFPLaneSpecificFilters> {}
export interface IRFPLaneFiltersRequest
  extends Omit<IRFPLaneFilters, 'currentPage' | 'showPagination' | 'pageTotalCount'> {}

export interface IRFPLaneCountResponse {
  count: number
}

/**
 * Endpoint for getting the list of RFP Lanes Rates
 * @method GET
 * @param {IRFPLaneFilters} params
 * @returns IRFPLaneResponse
 *
 */
const getRFPLanes = (params: IRFPLaneFiltersRequest): Promise<IRFPLaneResponse> => {
  return callApi({
    endpoint: ENDPOINTS.rfpLanes,
    method: 'GET',
    params,
  })
}

/**
 * Endpoint for getting the total count of RFP Lane Rates
 * @method GET
 * @returns IRFPLaneCountResponse
 *
 */
export const getRFPLaneCount = (params: IRFPLaneFiltersRequest): Promise<IRFPLaneCountResponse> =>
  callApi({
    endpoint: ENDPOINTS.rfpLanes,
    method: 'GET',
    group: 'count',
    params,
  })

export default getRFPLanes
